module.exports = __webpack_public_path__ + "static/template-home-about-hero-background-a3f393770e1ae00a1d1f7bc3af67adc1.jpg";